import React from 'react';
import { getPlatformLabel } from '../../../shared/config/platformConfig';

/**
 * CustomerDeleteModal - Confirmation modal for deleting a customer pass
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Object} props.customer - Customer object (optional, for displaying info)
 * @param {Function} props.onClose - Callback when modal is closed
 * @param {Function} props.onConfirm - Callback when deletion is confirmed
 */
export function CustomerDeleteModal({ isOpen, customer, onClose, onConfirm }) {
    if (!isOpen) {
        return null;
    }

    const platformDisplay = customer ? getPlatformLabel(customer.platform) : 'wallet';

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">Confirm Deletion</h3>
                <p className="text-gray-600 mb-6">
                    Are you sure you want to delete this customer's {platformDisplay} pass? This action cannot be undone.
                </p>
                <div className="flex justify-end space-x-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 text-gray-800"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 rounded bg-red-600 hover:bg-red-700 text-white"
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
}

